"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classMap_1 = __importDefault(require("./classMap"));
/**
 * @function deepMerge
 * @param {object} target Target object
 * @param {object} source Source object
 * @description Deeply merges multi-level objects
 * @returns {object} merged object
 */
var deepMerge = function (target, source) {
    var sourceObj = source;
    Object.keys(sourceObj).map(function (key) {
        // read only getter, use source[key] to set
        var current = sourceObj[key];
        // class names appeneded with classMap
        if (key.toLowerCase().indexOf("classname") > -1 && typeof current === "string") {
            sourceObj[key] = (0, classMap_1.default)(current, target[key]);
        }
        // unconfirmed -- concatenate arrays then deep merge
        else if (current instanceof Array) {
            sourceObj[key].push(deepMerge(target[key] || [], current));
        }
        // objects (not functions), perform deep merge
        else if (current instanceof Object && typeof current !== "function") {
            sourceObj[key] = __assign(__assign({}, current), deepMerge(target[key] || {}, current));
        }
        return sourceObj[key];
    });
    // join target object and modified source object
    return __assign(__assign({}, (target || {})), sourceObj);
};
exports.default = deepMerge;
